"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _exportNames = {
  FiftyFifty: true,
  FiftyFiftyReducers: true
};
exports.FiftyFiftyReducers = exports.FiftyFifty = void 0;
var _fiftyFifty = _interopRequireDefault(require("./components/fifty-fifty"));
exports.FiftyFifty = _fiftyFifty["default"];
var _reducers = require("./reducers");
exports.FiftyFiftyReducers = _reducers.FiftyFiftyReducers;
var _fiftyFifty2 = require("./components/fifty-fifty.propTypes");
Object.keys(_fiftyFifty2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _fiftyFifty2[key]) return;
  exports[key] = _fiftyFifty2[key];
});